import React from 'react';

import { Box, Button, Paper, TextField } from '@mui/material';

import { IAIModelClassLabelProps } from 'src/features/ai_model/domain/types';

const AIModelClassLabel: React.FC<IAIModelClassLabelProps> = ({
	row,
	isLoading,
	disabled,
	isTemp,
	canUpdate,
	onClassLabelInputChange,
	onUpdateClassLabelRow,
	onRemoveClassLabelRow,
}) => (
	<Paper
		variant='outlined'
		sx={{
			p: 1.5,
			display: 'grid',
			gridTemplateColumns: '1fr 2fr 0.5fr',
			gap: 2,
			alignItems: 'center',
			borderRadius: '4px',
			border: isTemp ? '1px solid #FF574D' : '1px solid transparent',
			transition: 'border-color 0.2s, background-color 0.2s',
		}}
	>
		<TextField
			size='small'
			value={row.classId}
			onChange={(event) =>
				onClassLabelInputChange(row.id, 'classId', event.target.value)
			}
			placeholder='Class ID'
			disabled={isLoading}
		/>
		<TextField
			size='small'
			value={row.label}
			onChange={(event) =>
				onClassLabelInputChange(row.id, 'label', event.target.value)
			}
			placeholder='Label'
			disabled={isLoading}
		/>
		<Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
			<Button
				variant='text'
				onClick={() => onUpdateClassLabelRow(row.id)}
				disabled={isLoading || disabled || !canUpdate}
				size='small'
			>
				Save
			</Button>
			<Button
				variant='text'
				color='error'
				onClick={() => onRemoveClassLabelRow(row.id)}
				disabled={isLoading || disabled}
				size='small'
			>
				Remove
			</Button>
		</Box>
	</Paper>
);

export default AIModelClassLabel;
